export var AppStatus;
(function (AppStatus) {
    /**  未安装 */
    AppStatus[AppStatus["NOINSTALL"] = 0] = "NOINSTALL";
    /**  下载中 */
    AppStatus[AppStatus["DOWNLOADING"] = 1] = "DOWNLOADING";
    /**  下载暂停 */
    AppStatus[AppStatus["DOWNLOAD_PAUSE"] = 2] = "DOWNLOAD_PAUSE";
    /**  下载失败 */
    AppStatus[AppStatus["DOWNLOAD_FAIL"] = 3] = "DOWNLOAD_FAIL";
    /**  下载完成，未安装 */
    AppStatus[AppStatus["DOWNLOADED"] = 4] = "DOWNLOADED";
    /**  安装中 */
    AppStatus[AppStatus["INSTALLING"] = 5] = "INSTALLING";
    /**  已安装 */
    AppStatus[AppStatus["INSTALLED"] = 6] = "INSTALLED";
})(AppStatus || (AppStatus = {}));
export var AppShowStatus = {
    NOINSTALL: 'noinstall',
    INSTALLED: 'installed'
};
export var AppDownloadStatus = {
    TASK_STATUS_NONE: 'TASK_STATUS_NONE',
    TASK_STATUS_CREATED: 'TASK_STATUS_CREATED',
    TASK_STATUS_STARTED: 'TASK_STATUS_STARTED',
    TASK_STATUS_PROGRESS: 'TASK_STATUS_PROGRESS',
    TASK_STATUS_COMPLETED: 'TASK_STATUS_COMPLETED',
    TASK_STATUS_TIMEOUT: 'TASK_STATUS_TIMEOUT',
    TASK_STATUS_FAILED: 'TASK_STATUS_FAILED',
    TASK_STATUS_CANCELED: 'TASK_STATUS_CANCELED',
    TASK_STATUS_DELETED: 'TASK_STATUS_DELETED',
    TASK_STATUS_FILE_HAS_DELETED: 'TASK_STATUS_FILE_HAS_DELETED' // 下载文件被删除
};
export var StatAction;
(function (StatAction) {
    StatAction["COMPONENT_SHOW"] = "SHOW";
    StatAction["COMPONENT_CLICK"] = "CLICK";
    StatAction["COMPONENT_CLOSE"] = "CLOSE";
})(StatAction || (StatAction = {}));
export var AppReportAction;
(function (AppReportAction) {
    // 按钮曝光
    AppReportAction["APP_SHOW_DOWNLOAD"] = "APP_SHOW_DOWNLOAD";
    // 按钮点击
    AppReportAction["APP_CLICK_DOWNLOAD"] = "APP_CLICK_DOWNLOAD";
    // 下载开始 - 内核统计
    AppReportAction["APP_START_DOWNLOAD"] = "APP_START_DOWNLOAD";
    // 下载暂停
    AppReportAction["APP_PAUSE_DOWNLOAD"] = "APP_PAUSE_DOWNLOAD";
    // 下载继续
    AppReportAction["APP_DOWNLOAD_RESUME"] = "APP_DOWNLOAD_RESUME";
    // 曾经已下载，复用包
    AppReportAction["APP_DOWNLOAD_ALREADY"] = "APP_DOWNLOAD_ALREADY";
    // 下载失败
    AppReportAction["APP_DOWNLOAD_FAILED"] = "APP_DOWNLOAD_FAILED";
    // 下载完成 - 内核统计
    AppReportAction["APP_FINISH_DOWNLOAD"] = "APP_FINISH_DOWNLOAD";
    // 安装开始
    AppReportAction["INSTALL_START"] = "INSTALL_START";
    // 安装取消
    AppReportAction["INSTALL_CANCEL"] = "INSTALL_CANCEL";
    // 安装失败
    AppReportAction["INSTALL_FAILED"] = "INSTALL_FAILED";
    // 安装成功 - 内核统计
    AppReportAction["INSTALL_SUCCESS"] = "INSTALL_SUCCESS";
    // 安装完成 - 页面统计
    AppReportAction["INSTALL_END"] = "INSTALL_END";
    // 打开应用
    AppReportAction["APP_OPEN"] = "APP_OPEN";
    // 自动激活
    AppReportAction["AUTO_ACTIVE"] = "AUTO_ACTIVE";
    // 安装完自动拉活
    AppReportAction["INSTALL_AUTO_ACTIVE"] = "INSTALL_AUTO_ACTIVE";
    // 尝试调起异常
    AppReportAction["TRY_OPEN_FAILED"] = "TRY_OPEN_FAILED";
})(AppReportAction || (AppReportAction = {}));
// 1=ug 2=dsp 3=rmp
// export const SmpStatMap = {
//     1: {},
//     2: {},
//     3: {}
// }
